import { appApi } from './app_api';

export const eventsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: (filters = {}) => {
        const queryString = Object.keys(filters)
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filters[key]))
          .join('&');
        if (queryString.length === 0) {
          return `/events`;
        }
        return `/events?${queryString}`;
      },
      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Event', id })),
              { type: 'Events', id: 'LIST' },
            ]
          : [{ type: 'Events', id: 'LIST' }],
    }),
    // Global upcoming events (public home page). Named distinctly from the
    // customer-scoped getUpcomingEvents in customer_events_endpoints.
    getAllUpcomingEvents: builder.query({
      query: () => `/events/upcoming`,
      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Event', id })),
              { type: 'Events', id: 'LIST' },
            ]
          : [{ type: 'Events', id: 'LIST' }],
    }),
    getPlayersForRound: builder.query({
      query: ({ eventId, roundId }) => `/events/${eventId}/players/for_round?round_id=${roundId}`,
      transformResponse: (response) => Array.isArray(response.data) ? response.data : [],
      providesTags: (result, error, { eventId }) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Player', id })),
              { type: 'EventPlayersForRound', id: eventId },
            ]
          : [{ type: 'EventPlayersForRound', id: eventId }],
    }),
    getEventPlayersForSelect: builder.query({
      query: (eventId) => `/events/${eventId}/players/list_for_select`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventSimplePlayers', id: eventId }],
    }),
    createInstance: builder.mutation({
      query: ({ groupId, playerId }) => ({
        url: `/groups/${groupId}/player_instances`,
        method: 'POST',
        body: { player_id: playerId },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventPlayersForRound', id: eventId }],
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetAllUpcomingEventsQuery,
  useGetPlayersForRoundQuery,
  useGetEventPlayersForSelectQuery,
  useCreateInstanceMutation,
} = eventsApi;
